import React from 'react';
import { connect } from 'dva';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Row, Col, Table, Tooltip, Spin, Icon, Button, Modal } from 'antd';
import { Link } from 'dva/router';
import Sticky from 'react-sticky-el';
import { AjaxTable, SearchComponent } from '../../../components';
import { PencilIcon, TrashIcon } from '../../Icons';
import {
  ACTION_APP_GO_TO_ROUTE,
  ACTION_APP_SHOW_NOTIFICATION,
} from '../../../models/app';
import {
  ACTION_CLIENT_PACKAGES_DELETE,
  ACTION_CLIENT_PACKAGES_LOADLIST,
} from '../../../models/clientPackages';
import styles from './../styles.less';
import { ROUTE_CLIENT_PACKAGES_NEW } from '../../../routes';

const { Column } = Table;

class ClientPackagesList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      removedId: 0,
      filter: {
        search: undefined,
      },
    };
  }

  componentDidMount() {
    this.props.dispatch({
      type: 'header/update',
      payload: {
        title: 'Component.Administration.ClientPackages.List.Title',
        description: 'Component.Administration.ClientPackages.List.Description',
      },
    });

    this.showNotifications();
  }

  getData = (psf) => {
    const filter = {
      title: this.state.filter.search,
    };

    return this.props.dispatch({
      type: ACTION_CLIENT_PACKAGES_LOADLIST,
      payload: { filter, ...psf },
    });
  };

  goToClientPackagesNew = () => {
    this.props.dispatch({
      type: ACTION_APP_GO_TO_ROUTE,
      payload: { routeName: ROUTE_CLIENT_PACKAGES_NEW },
    });
  };

  showNotifications() {
    this.props.dispatch({ type: ACTION_APP_SHOW_NOTIFICATION });
  }

  showDeleteConfirm = (clientPackage) => {
    Modal.confirm({
      title: this.props.intl.formatMessage({ id: 'Common.Attention' }),
      content: this.props.intl.formatMessage(
        { id: 'Component.Administration.ClientPackages.Remove.Modal.Description' },
        { clientPackage: clientPackage.title },
      ),
      okText: this.props.intl.formatMessage({ id: 'Common.Remove' }),
      cancelText: this.props.intl.formatMessage({ id: 'Common.Cancel' }),
      okType: 'danger',
      onOk: () => this.removeClientPackage(clientPackage),
    });
  }

  removeClientPackage = (clientPackage) => {
    this.props
      .dispatch({ type: ACTION_CLIENT_PACKAGES_DELETE, payload: { id: clientPackage.id } })
      .then((success) => {
        if (!success) {
          return;
        }

        this.showNotifications();
        this.setState({ removedId: clientPackage.id });
      });
  }

  render() {
    const { filter } = this.state;
    const { loading } = this.props;

    return (
      <div className={styles.containerLarge}>
        <Sticky
          className="sticky-bar"
          scrollElement=".ant-layout"
          stickyClassName="_sticky"
        >
          <div className="sticky-wrapper">
            <Row gutter={6}>
              <SearchComponent
                self={this}
                fieldPlaceholder={this.props.intl.formatMessage({
                  id: 'Component.Administration.ClientPackages.List.SearchByTitlePlaceholder',
                })}
              />
              <Col span={14} className="text-right">
                <Button
                  size="large"
                  type="primary"
                  onClick={this.goToClientPackagesNew}
                >
                  <Icon type="plus" />
                  <FormattedMessage id="Component.Administration.ClientPackages.List.Create" />
                </Button>
              </Col>
            </Row>
          </div>
        </Sticky>
        <Spin spinning={loading.models.clientPackages || loading.models.app}>
          <AjaxTable
            getData={this.getData}
            rowKey="id"
            updateKey={JSON.stringify([filter, this.state.removedId])}
          >
            <Column
              dataIndex="title"
              title={this.props.intl.formatMessage({ id: 'Component.Administration.ClientPackages.Form.Title' })}
              sorter
              render={data => <div>{data}</div>}
            />
            <Column
              dataIndex="monthly_limit"
              title={this.props.intl.formatMessage({ id: 'Component.Administration.ClientPackages.Form.MonthlyLimit' })}
              sorter
              render={data => <div>{data}</div>}
            />
            <Column
              title={this.props.intl.formatMessage({
                id: 'Grid.Column.Actions',
              })}
              key="actions"
              className="text-center"
              width={150}
              fixed="right"
              render={item => (
                <div className="actions" data-label={item.id}>
                  <Tooltip
                    className="hint action-wrap"
                    placement="top"
                    title={this.props.intl.formatMessage({
                      id: 'Grid.Column.Edit',
                    })}
                  >
                    <Link to={`./${item.id}/edit/`}>
                      <PencilIcon />
                    </Link>
                  </Tooltip>
                  <Tooltip
                    className="hint action-wrap"
                    placement="top"
                    title={this.props.intl.formatMessage({
                      id: 'Grid.Column.Delete',
                    })}
                  >
                    <button onClick={() => this.showDeleteConfirm(item)}>
                      <TrashIcon />
                    </button>
                  </Tooltip>
                </div>
              )}
            />
          </AjaxTable>
        </Spin>
      </div>
    );
  }
}

export default connect(({ loading, app }) => ({
  loading,
  app,
}))(injectIntl(ClientPackagesList));



// WEBPACK FOOTER //
// ./src/components/ClientPackages/ClientPackagesList/index.js